// Add to Cart — with fly-to-cart animation
async function addToCart(variantId, btn) {
  if (!btn) return;

  // Pincode gate
  if (window._smPinOk !== true) {
    // On PDP: shake the existing pincode zone
    if (window._smPinAlert && document.getElementById('pdp-pincode-zone')) {
      window._smPinAlert();
    } else {
      // On collection/other pages: show a modal
      _smPinModal(variantId, btn);
    }
    return;
  }

  const img = btn.closest('.pcard') ? btn.closest('.pcard').querySelector('img') : null;

  // Loading state
  btn.disabled = true;
  var origHTML = btn.innerHTML;
  btn.innerHTML = '<svg class="atc-spin" width="15" height="15" viewBox="0 0 15 15" fill="none" stroke-width="2" stroke-linecap="round"><circle cx="7.5" cy="7.5" r="5.5" stroke="rgba(255,255,255,.22)"/><path d="M7.5 2A5.5 5.5 0 0 1 13 7.5" stroke="#fff"/></svg>';

  try {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (res.ok) {
      // Update cart count badge
      var cart = await fetch('/cart.js').then(function(r) { return r.json(); });
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
        el.classList.remove('pop');
        void el.offsetWidth;
        el.classList.add('pop');
      });

      // Fly image to cart
      if (img) _atcFly(img);

      // Success state
      btn.classList.add('atc-ok');
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"><polyline class="check-draw" points="20 6 9 17 4 12"/></svg> Added!';

      // Toast
      _atcToast();

      setTimeout(function() {
        btn.classList.remove('atc-ok');
        btn.innerHTML = origHTML;
        btn.disabled = false;
      }, 2200);
    } else {
      btn.innerHTML = origHTML;
      btn.disabled = false;
    }
  } catch(e) {
    btn.innerHTML = origHTML;
    btn.disabled = false;
  }
}

function _atcFly(img) {
  var cartEl = document.querySelector('a.nico[href*="cart"]');
  if (!cartEl) return;
  var ir = img.getBoundingClientRect();
  var cr = cartEl.getBoundingClientRect();

  var fly = document.createElement('div');
  fly.className = 'atc-fly';
  fly.style.cssText = 'width:'+ir.width+'px;height:'+ir.height+'px;left:'+ir.left+'px;top:'+ir.top+'px;background-image:url('+img.src+');opacity:0';
  document.body.appendChild(fly);

  requestAnimationFrame(function() {
    fly.style.opacity = '1';
    requestAnimationFrame(function() {
      var sz = Math.max(cr.width, 34);
      fly.style.width  = sz+'px';
      fly.style.height = sz+'px';
      fly.style.left   = (cr.left + cr.width/2  - sz/2)+'px';
      fly.style.top    = (cr.top  + cr.height/2 - sz/2)+'px';
      fly.style.borderRadius = '50%';
      fly.style.opacity = '0';
    });
  });

  setTimeout(function() {
    fly.remove();
    cartEl.classList.remove('cart-hit');
    void cartEl.offsetWidth;
    cartEl.classList.add('cart-hit');
  }, 720);
}

var _atcToastTimer;
function _atcToast() {
  var toast = document.getElementById('atc-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'atc-toast';
    toast.className = 'atc-toast';
    toast.innerHTML = '<svg class="atc-toast-ico" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>Added to cart<a class="atc-toast-link" href="/cart">View Cart</a>';
    document.body.appendChild(toast);
  }
  clearTimeout(_atcToastTimer);
  toast.classList.remove('show');
  void toast.offsetWidth;
  toast.classList.add('show');
  _atcToastTimer = setTimeout(function() { toast.classList.remove('show'); }, 3200);
}

// Pincode delivery gate — null=unchecked, true=ok, false=blocked
window._smPinOk = null;

// ── Tab handler (inline onclick — must stay global)
function dt(btn, pid) {
  document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('on'));
  document.querySelectorAll('.tab-pane').forEach(p => p.classList.remove('on'));
  btn.classList.add('on');
  document.getElementById(pid).classList.add('on');
}

// ── Search: shared preprocessing & smart redirect ────────────────────────────

// Synonym map: abbreviations and common misspellings → full terms
var SM_SYNONYMS = [
  [/\bac\b/gi,             'air conditioner'],
  [/\bacs\b/gi,            'air conditioners'],
  [/\ba\.c\b/gi,           'air conditioner'],
  [/\btv\b/gi,             'television'],
  [/\btvs\b/gi,            'televisions'],
  [/\bfridge\b/gi,         'refrigerator'],
  [/\bfridges\b/gi,        'refrigerators'],
  [/\bwm\b/gi,             'washing machine'],
  [/\bwasher\b/gi,         'washing machine'],
  [/\bwashers\b/gi,        'washing machines'],
  [/\bmicrowave\b/gi,      'microwave oven'],
  [/\bcooler\b/gi,         'air cooler'],
  [/\bwater\s*purifier\b/gi,'water purifier'],
];

// Tonnage → collection tag handle (from Shopify handle filter on collection tags)
var SM_TONNAGE = [
  [0.99, 'tonnage-below-1-ton'],
  [1.40, 'tonnage-1-1-4-ton'],
  [1.95, 'tonnage-1-5-1-95-ton'],
  [2.40, 'tonnage-2-2-4-ton'],
  [99,   'tonnage-2-5-above-ton'],
];

function smPreprocess(q) {
  q = q.trim();
  SM_SYNONYMS.forEach(function(s) { q = q.replace(s[0], s[1]); });
  return q;
}

// Returns true and navigates if the query maps to a known redirect
function smRedirect(q) {
  var lower = q.toLowerCase().trim();

  // Pure category queries
  var cats = [
    [/^(air\s+conditioners?|ac|acs)$/,         '/collections/air-conditioners'],
    [/^(televisions?|tv|tvs)$/,                '/collections/televisions'],
    [/^(refrigerators?|fridge|fridges)$/,       '/collections/refrigerator'],
    [/^(washing\s+machines?|wm|washers?)$/,     '/collections/washing-machines'],
    [/^(microwave\s+ovens?|microwaves?)$/,      '/collections/microwave-ovens'],
  ];
  for (var i = 0; i < cats.length; i++) {
    if (cats[i][0].test(lower)) { window.location.href = cats[i][1]; return true; }
  }

  // "[N] ton [ac / air conditioner]" → AC collection filtered by tonnage tag
  var tonAc = lower.match(/(\d+(?:\.\d+)?)\s*ton.*(?:ac|air\s*conditioner)/);
  if (tonAc) {
    var ton = parseFloat(tonAc[1]);
    for (var j = 0; j < SM_TONNAGE.length; j++) {
      if (ton <= SM_TONNAGE[j][0]) {
        window.location.href = '/collections/air-conditioners/' + SM_TONNAGE[j][1];
        return true;
      }
    }
  }

  // "[brand] ac" → AC collection (search within it)
  if (/\b(ac|air\s*conditioner)s?\b/.test(lower) && !/\d+\s*ton/.test(lower)) {
    var brand = lower.replace(/\b(ac|air\s*conditioners?)\b/g, '').trim();
    if (brand.length > 1) {
      window.location.href = '/collections/air-conditioners?q=' + encodeURIComponent(brand);
      return true;
    }
  }

  // "[brand] tv" → TV collection
  if (/\b(tv|televisions?)\b/.test(lower)) {
    var tvBrand = lower.replace(/\b(tv|televisions?)\b/g, '').trim();
    if (tvBrand.length > 1) {
      window.location.href = '/collections/televisions?q=' + encodeURIComponent(tvBrand);
      return true;
    }
  }

  return false;
}

// Wire up any search form: try smart redirect, then preprocess before submit
function smWireForm(formId, inputId) {
  var form = document.getElementById(formId);
  var inp  = document.getElementById(inputId);
  if (!form || !inp) return;
  form.addEventListener('submit', function(e) {
    var raw = inp.value.trim();
    if (!raw) return;
    if (smRedirect(raw)) { e.preventDefault(); return; }
    inp.value = smPreprocess(raw);
  });
}

// ── Search results phrase post-filter ────────────────────────────────────────
// Runs on the search page. Hides cards whose title doesn't contain all
// phrase-level constraints (e.g. "2 ton" must appear as a substring, not just
// "2" and "ton" independently — that's what causes the bug).
function smPhraseFilter(rawTerms) {
  if (!rawTerms) return;
  var lower = rawTerms.toLowerCase();

  var constraints = []; // phrases that MUST appear as substrings in the title

  // Tonnage phrase: "2 ton" → must appear as "2 ton" (or "2.0 ton") in title
  var tonM = lower.match(/(\d+(?:\.\d+)?)\s*ton/);
  if (tonM) {
    var tv = parseFloat(tonM[1]);
    // Accept 2 ton to also match "2.0 ton" etc.
    constraints.push({ type: 'ton', val: tv });
  }

  // Screen size phrase: "75 inch" → must appear as "75" in title (sizes vary: "75\"", "75 inch", "75-inch")
  var inchM = lower.match(/(\d{2,3})\s*inch/);
  if (inchM) constraints.push({ type: 'inch', val: inchM[1] });

  if (constraints.length === 0) return;

  document.querySelectorAll('.pcard').forEach(function(card) {
    var nameEl = card.querySelector('.pc-name');
    if (!nameEl) return;
    var title = nameEl.textContent.toLowerCase();

    var show = constraints.every(function(c) {
      if (c.type === 'ton') {
        // Match "2 ton", "2.0 ton", "2-ton" etc.
        return new RegExp('\\b' + c.val + '(?:\\.0)?\\s*(?:-|\\s)\\s*ton').test(title);
      }
      if (c.type === 'inch') {
        return new RegExp('\\b' + c.val + '\\b').test(title);
      }
      return true;
    });

    if (!show) card.style.display = 'none';
  });
}

// ── Pincode modal (for collection / non-PDP pages) ───────────────────────────
function _smPinModal(variantId, btn) {
  var existing = document.getElementById('sm-pin-modal');
  if (existing) existing.remove();

  var modal = document.createElement('div');
  modal.id = 'sm-pin-modal';
  modal.className = 'sm-pin-modal';
  modal.innerHTML =
    '<div class="sm-pin-modal-box">' +
      '<button class="sm-pin-modal-close" aria-label="Close">&#10005;</button>' +
      '<div class="sm-pin-modal-ico">📍</div>' +
      '<div class="sm-pin-modal-title">Check Delivery</div>' +
      '<div class="sm-pin-modal-sub">We deliver within Mumbai &amp; Thane. Enter your pincode to confirm before adding to cart.</div>' +
      '<div class="sm-pin-modal-row">' +
        '<input class="sm-pin-modal-inp" type="tel" maxlength="6" placeholder="6-digit pincode" inputmode="numeric">' +
        '<button class="sm-pin-modal-btn">Check</button>' +
      '</div>' +
      '<div class="sm-pin-modal-result" hidden></div>' +
    '</div>';
  document.body.appendChild(modal);

  var inp     = modal.querySelector('.sm-pin-modal-inp');
  var chkBtn  = modal.querySelector('.sm-pin-modal-btn');
  var result  = modal.querySelector('.sm-pin-modal-result');
  var closeBtn = modal.querySelector('.sm-pin-modal-close');

  setTimeout(function() { inp.focus(); }, 60);

  function isMumbaiPin(pin) { return /^(400|421)\d{3}$/.test(pin); }

  function checkPin() {
    var pin = inp.value.trim();
    if (pin.length !== 6 || !/^\d{6}$/.test(pin)) {
      result.hidden = false;
      result.style.color = '#e61e2b';
      result.textContent = 'Please enter a valid 6-digit pincode.';
      return;
    }
    chkBtn.textContent = 'Checking…';
    chkBtn.disabled = true;
    setTimeout(function() {
      chkBtn.textContent = 'Check';
      chkBtn.disabled = false;
      if (isMumbaiPin(pin)) {
        window._smPinOk = true;
        modal.remove();
        addToCart(variantId, btn);
      } else {
        window._smPinOk = false;
        result.hidden = false;
        result.style.color = '#e61e2b';
        result.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#e61e2b" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> Sorry, we only deliver within Mumbai &amp; Thane.';
      }
    }, 700);
  }

  closeBtn.addEventListener('click', function() { modal.remove(); });
  modal.addEventListener('click', function(e) { if (e.target === modal) modal.remove(); });
  chkBtn.addEventListener('click', checkPin);
  inp.addEventListener('keydown', function(e) { if (e.key === 'Enter') checkPin(); });

  /* Auto-fill pincode: cached → geolocation */
  (function() {
    function tryFill(zip) {
      if (!zip || !/^\d{6}$/.test(zip)) return;
      inp.value = zip;
      checkPin();
    }
    try {
      var c = JSON.parse(localStorage.getItem('sm_defaddr') || 'null');
      if (c && c.zip && /^\d{6}$/.test(c.zip)) { tryFill(c.zip); return; }
    } catch(e) {}
    if (!navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(function(pos) {
      fetch('https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1&lat=' +
        pos.coords.latitude + '&lon=' + pos.coords.longitude)
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var zip = ((d.address && d.address.postcode) || '').replace(/\s/g, '');
        if (/^\d{6}$/.test(zip)) {
          try {
            var ex = JSON.parse(localStorage.getItem('sm_defaddr') || '{}');
            ex.zip = zip;
            localStorage.setItem('sm_defaddr', JSON.stringify(ex));
          } catch(e2) {}
          tryFill(zip);
        }
      }).catch(function() {});
    }, function() {}, { timeout: 5000 });
  })();
}

// ── DOMContentLoaded ─────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {

  // Wire search forms
  smWireForm('srch-overlay-form', 'search-input');
  smWireForm('srch-pg-form',      'srch-pg-q');

  // Auto-run phrase filter on search results page
  var termsEl = document.getElementById('sm-search-terms');
  if (termsEl) smPhraseFilter(termsEl.dataset.terms);

  // ── Pincode checker
  var pinBtn = document.querySelector('.pi-pin-btn');
  var pinInp = document.querySelector('.pi-pin-inp');
  var pinResult = document.getElementById('pdp-pin-result');
  if (pinBtn && pinInp) {
    // Mumbai: 400xxx (city, all suburbs, Navi Mumbai, Thane city)
    // Thane district: 421xxx (Kalyan, Dombivli, Ulhasnagar, Ambernath, Bhiwandi, Badlapur)
    function isMumbaiPin(pin) {
      return /^(400|421)\d{3}$/.test(pin);
    }

    // Show shake + scroll to pincode zone when CTA is clicked while blocked
    window._smPinAlert = function() {
      var zone = document.getElementById('pdp-pincode-zone');
      if (!zone) return;
      zone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      zone.classList.remove('pin-shake');
      void zone.offsetWidth;
      zone.classList.add('pin-shake');
      setTimeout(function() { zone.classList.remove('pin-shake'); }, 500);
      var inp = zone.querySelector('.pi-pin-inp');
      if (inp) { inp.focus(); inp.select(); }
    };

    function _smPinSetBtns(blocked) {
      ['pdp-buy-btn', 'pdp-cart-btn'].forEach(function(id) {
        var b = document.getElementById(id);
        if (b) b.classList[blocked ? 'add' : 'remove']('pin-blocked');
      });
    }

    function checkPin() {
      var pin = pinInp.value.trim();
      if (pin.length !== 6 || !/^\d{6}$/.test(pin)) {
        pinInp.style.borderColor = '#e61e2b';
        if (pinResult) {
          pinResult.hidden = false;
          pinResult.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#e61e2b" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg> Please enter a valid 6-digit pincode.';
          pinResult.style.color = '#e61e2b';
        }
        return;
      }
      pinInp.style.borderColor = '';
      pinBtn.textContent = 'Checking…';
      pinBtn.disabled = true;
      setTimeout(function () {
        pinBtn.textContent = 'Check';
        pinBtn.disabled = false;
        if (pinResult) {
          pinResult.hidden = false;
          if (isMumbaiPin(pin)) {
            pinResult.style.color = '';
            pinResult.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1a7a48" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Free delivery available to <strong>' + pin + '</strong>. Expected in 1–2 business days.';
            window._smPinOk = true;
            _smPinSetBtns(false);
          } else {
            pinResult.style.color = '#e61e2b';
            pinResult.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#e61e2b" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> Sorry, we currently deliver only within Mumbai &amp; Thane.';
            window._smPinOk = false;
            _smPinSetBtns(true);
          }
        }
      }, 700);
    }

    pinBtn.addEventListener('click', checkPin);
    pinInp.addEventListener('keydown', function(e) { if (e.key === 'Enter') checkPin(); });
    pinInp.addEventListener('input', function() {
      if (pinResult) { pinResult.hidden = true; pinResult.style.color = ''; }
      pinInp.style.borderColor = '';
      window._smPinOk = null;
      _smPinSetBtns(true);
    });

    /* Auto-detect pincode: Shopify address → geolocation → cached */
    (function() {
      function applyPin(zip) {
        if (!zip || !/^\d{6}$/.test(zip)) return;
        pinInp.value = zip;
        checkPin();
      }

      function fromGeolocation(fallbackZip) {
        if (!navigator.geolocation) { if (fallbackZip) applyPin(fallbackZip); return; }
        navigator.geolocation.getCurrentPosition(
          function(pos) {
            fetch(
              'https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1' +
              '&lat=' + pos.coords.latitude +
              '&lon=' + pos.coords.longitude
            )
            .then(function(r) { return r.json(); })
            .then(function(d) {
              var zip = ((d.address && d.address.postcode) || '').replace(/\s/g, '');
              if (/^\d{6}$/.test(zip)) {
                var city = (d.address && (d.address.city || d.address.town || d.address.village || d.address.suburb)) || '';
                try {
                  var ex = JSON.parse(localStorage.getItem('sm_defaddr') || '{}');
                  ex.zip  = zip;
                  ex.city = city;
                  localStorage.setItem('sm_defaddr', JSON.stringify(ex));
                } catch(e) {}
                applyPin(zip);
              } else if (fallbackZip) {
                applyPin(fallbackZip);
              }
            })
            .catch(function() { if (fallbackZip) applyPin(fallbackZip); });
          },
          function() { if (fallbackZip) applyPin(fallbackZip); },
          { timeout: 6000 }
        );
      }

      var tk  = localStorage.getItem('sm_tk');
      var sfT = window.smSFTok;

      function getCachedZip() {
        try { var c = JSON.parse(localStorage.getItem('sm_defaddr') || 'null'); return (c && c.zip) ? c.zip : null; } catch(e) { return null; }
      }

      /* Auto-detect only when user taps the input — never on page load */
      var _pinAutoRan = false;
      pinInp.addEventListener('focus', function() {
        if (_pinAutoRan || pinInp.value.trim().length > 0) return;
        _pinAutoRan = true;

        if (tk && sfT) {
          fetch('https://sony-mony-electronics.myshopify.com/api/2024-10/graphql.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': sfT },
            body: JSON.stringify({
              query: 'query($t:String!){customer(customerAccessToken:$t){defaultAddress{zip city address1 firstName phone}}}',
              variables: { t: tk }
            })
          })
          .then(function(r) { return r.json(); })
          .then(function(res) {
            var a = res.data && res.data.customer && res.data.customer.defaultAddress;
            if (a && a.zip) {
              try { localStorage.setItem('sm_defaddr', JSON.stringify({ zip: a.zip, city: a.city, address1: a.address1, firstName: a.firstName, phone: a.phone })); } catch(e) {}
              applyPin(a.zip);
            } else {
              var z = getCachedZip(); if (z) applyPin(z); else fromGeolocation(null);
            }
          })
          .catch(function() { var z = getCachedZip(); if (z) applyPin(z); else fromGeolocation(null); });
        } else {
          var cachedZip = getCachedZip();
          if (cachedZip) applyPin(cachedZip); else fromGeolocation(null);
        }
      }, { once: false });
    })();
  }

  // ── Scroll reveal
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (x) {
      if (x.isIntersecting) { x.target.classList.add('in'); obs.unobserve(x.target); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.rv').forEach(function (el) { obs.observe(el); });

});

// ── Collection sidebar: inject any Brand tags present in product cards but missing from sidebar ──
(function() {
  var grid = document.getElementById('prodGrid');
  var sidebar = document.getElementById('collSidebar');
  if (!grid || !sidebar) return;

  var brandSection = null;
  sidebar.querySelectorAll('.sb-s').forEach(function(sec) {
    var h = sec.querySelector('.sb-h');
    if (h && h.childNodes[0] && h.childNodes[0].textContent.trim() === 'Brand') brandSection = sec;
  });
  if (!brandSection) return;

  var brandsInProducts = {};
  grid.querySelectorAll('[data-tags]').forEach(function(card) {
    (card.dataset.tags || '').split('|').forEach(function(tag) {
      if (tag.indexOf('Brand_') === 0) brandsInProducts[tag] = true;
    });
  });

  var brandsInSidebar = {};
  brandSection.querySelectorAll('input[data-tag]').forEach(function(inp) {
    brandsInSidebar[inp.dataset.tag] = true;
  });

  Object.keys(brandsInProducts).sort().forEach(function(tag) {
    if (brandsInSidebar[tag]) return;
    var label = document.createElement('label');
    label.className = 'sb-row';
    var inp = document.createElement('input');
    inp.type = 'checkbox';
    inp.dataset.tag = tag;
    inp.setAttribute('onclick', 'smToggleFilter(event, this)');
    var sp = document.createElement('span');
    sp.textContent = tag.replace('Brand_', '');
    label.appendChild(inp);
    label.appendChild(sp);
    brandSection.appendChild(label);
  });
})();
